import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconNjoftimet = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 13.3 20",
	style: { enableBackground: "new 0 0 13.3 20" },
	xmlSpace: "preserve",
	fill: "#fbfbfb",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group_4167_00000116945937068869774290000006983776868870901151_",
		transform: "translate(-3633.5 75)",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Path_7413_00000169551406889492978480000003617827709912210329_",
			d: "M3638.5-56.8v0.2c0,0.8,0.7,1.5,1.5,1.5 h0.3c0.8,0,1.5-0.7,1.5-1.5v-0.2H3638.5z"
		}), /* @__PURE__ */ _jsx("path", {
			id: "Path_7414_00000160884763990628686030000012834844531731564702_",
			d: "M3646.7-61.5c-1-1.4-1.6-3.1-1.6-4.9 v-1.5c0-2.4-1.6-4.5-3.9-5v-1c0-0.6-0.5-1-1-1h-0.2c-0.6,0-1,0.5-1,1c0,0,0,0,0,0v1c-2.3,0.5-3.9,2.5-3.9,4.9v1.7 c0,1.7-0.5,3.4-1.6,4.9c-0.1,0.1-0.1,0.2-0.1,0.3v2.6c0,0.3,0.2,0.6,0.6,0.6h12.2c0.3,0,0.6-0.2,0.6-0.6l0,0v-2.6 C3646.8-61.3,3646.8-61.4,3646.7-61.5"
		})]
	})
});
export { SvgIconNjoftimet as ReactComponent };
